import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const languages = [
    { code: 'bg', name: 'Български', flag: '🇧🇬' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'ro', name: 'Română', flag: '🇷🇴' },
    { code: 'pl', name: 'Polski', flag: '🇵🇱' },
    { code: 'cs', name: 'Čeština', flag: '🇨🇿' },
    { code: 'sk', name: 'Slovenčina', flag: '🇸🇰' },
    { code: 'sr', name: 'Srpski', flag: '🇷🇸' },
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
    { code: 'uk', name: 'Українська', flag: '🇺🇦' },
];

const CustomLanguageSelector = () => {
    const [currentLang, setCurrentLang] = useState('bg');
    const [renderKey, setRenderKey] = useState(0);

    setTimeout(() => {
        const gFrame = document.querySelector('iframe.goog-te-banner-frame');
        if (gFrame) {
            const categoriesWrapper = document.querySelector('.category-tabs'); // или твоя клас
            if (categoriesWrapper) {
                const dummy = document.createElement('span');
                dummy.innerText = '.';
                dummy.style.opacity = '0';
                categoriesWrapper.appendChild(dummy);
                setTimeout(() => dummy.remove(), 100);
            }
        }
    }, 1000);


    useEffect(() => {
        const cookieLang = cookies.get('googtrans')?.split('/')?.[2];
        if (cookieLang) {
            setCurrentLang(cookieLang);
        }
        const lang = localStorage.getItem('googtrans')?.split('/')[2];
        if (lang) {
            setTimeout(() => setRenderKey(prev => prev + 1), 1200); // ще форсира превод
        }

    }, []);

    const setGoogleTranslateLang = (langCode) => {
        cookies.set('googtrans', `/bg/${langCode}`, { path: '/' });
        cookies.set('googtrans', `/bg/${langCode}`, { domain: '.tabl.bg', path: '/' });
        setCurrentLang(langCode);

        const tryChange = (attempt = 0) => {
            const combo = document.querySelector('.goog-te-combo');
            if (combo) {
                combo.value = langCode;
                combo.dispatchEvent(new Event('change'));
            } else if (attempt < 10) {
                setTimeout(() => tryChange(attempt + 1), 300);
            }
        };

        tryChange();
    };

    return (
        <select
            onChange={(e) => setGoogleTranslateLang(e.target.value)}
            value={currentLang}
            className="skiptranslate notranslate"
            style={{
                padding: '5px 10px',
                borderRadius: 5,
                fontSize: 14,
                fontWeight: 'bold',
                textAlign: 'center',
                cursor: 'pointer',
                marginTop: 10,
            }}
        >
            {languages.map((lang) => (
                <option key={lang.code} value={lang.code}>
                    {lang.flag} {lang.name}
                </option>
            ))}
        </select>
    );
};

export default CustomLanguageSelector;
